import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';
import { NodeIds, NodeTypeKeys } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/utils/NodeTypeKeys';
import { BranchControlNode } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Entities/Nodes/BranchControlNode';
import { useBranches } from '../../../../state/Branches/hooks/useBranches';
import { BranchesPayload } from '../../../../state/Branches/BranchesState';

export const useAddBranchControlToWorkFlow = () => {
  const { dispatch, state } = useWorkFlowCanvas();
  const { addBranches } = useBranches();

  return useCallback(
    (addToId: string) => {
      const { nodes, edges } = Canvas.createFromState(state)
        .hideDropNodesFor(NodeTypeKeys.branchControlNodeType)
        .add(new BranchControlNode(NodeIds.branchControl, NodeTypeKeys.displayWebContentNodeType), addToId)
        .convertToState();

      const branchNodes = nodes.filter(s => s.type === NodeTypeKeys.branchNameNodeType);
      const branches: BranchesPayload = branchNodes.reduce((current, next, i) => {
        return {
          ...current,
          [next.id]: { id: next.id, name: `Branch #${i + 1}` },
        };
      }, {});

      addBranches(branches);

      dispatch({
        type: 'UPDATE',
        payload: {
          nodes,
          edges,
        },
      });
    },
    [addBranches, dispatch, state],
  );
};
